import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Button from "../components/atoms/Button";
import Input from "../components/molecules/Input";
import Text from "../components/atoms/Text";
import { useUser } from "../context/UserContext";

export default function Auth() {
  const navigate = useNavigate();
  const { signIn, signUp, signInWithGoogle } = useUser();
  const [mode, setMode] = useState("login");
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [registerName, setRegisterName] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  async function handleLoginSubmit(event) {
    event.preventDefault();
    const result = await signIn({
      email: loginEmail,
      password: loginPassword,
    });

    if (result?.success) {
      navigate("/");
    }
  }

  async function handleSignUp(event) {
    event.preventDefault();

    if (!acceptTerms) {
      return;
    }

    const result = await signUp({
      name: registerName,
      email: registerEmail,
      password: registerPassword,
      confirmPassword,
    });

    if (result?.success) {
      navigate("/");
    }
  }

  async function handleGoogleAuth() {
    const result = await signInWithGoogle();

    if (result?.success) {
      navigate("/");
    }
  }

  const cardStyle = {
    width: "424px",
    backgroundColor: "var(--white)",
    borderRadius: "8px",
    border: "1px solid var(--gray05)",
    boxShadow: "0 20px 48px rgba(0, 38, 3, 0.08)",
    padding: "24px 24px 28px",
  };

  const inputShellStyle = {
    position: "relative",
  };

  const passwordToggleStyle = {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    border: "none",
    backgroundColor: "transparent",
    color: "var(--gray4)",
    cursor: "pointer",
    padding: 0,
    fontSize: "14px",
    lineHeight: 1,
  };

  return (
    <div
      className="auth-page"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--white)",
        padding: "32px 16px",
      }}
    >
      <div className="auth-card" style={cardStyle}>
        <Text
          size="px32"
          weight="w600"
          color="gray9"
          extraStyles={{ textAlign: "center", marginBottom: "20px" }}
        >
          {mode === "login" ? "Sign In" : "Create Account"}
        </Text>

        {mode === "login" ? (
          <form
            onSubmit={handleLoginSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <Input
              type="email"
              placeholder="Email"
              value={loginEmail}
              onChange={(event) => setLoginEmail(event.target.value)}
              width="100%"
              containerStyle={{ maxWidth: "100%" }}
              inputStyle={{ fontSize: "14px", padding: "14px 16px" }}
            />

            <div style={inputShellStyle}>
              <Input
                type={showLoginPassword ? "text" : "password"}
                placeholder="Password"
                value={loginPassword}
                onChange={(event) => setLoginPassword(event.target.value)}
                width="100%"
                containerStyle={{ maxWidth: "100%" }}
                inputStyle={{ fontSize: "14px", padding: "14px 42px 14px 16px" }}
              />
              <button
                type="button"
                onClick={() => setShowLoginPassword((current) => !current)}
                style={passwordToggleStyle}
              >
                <FontAwesomeIcon icon={showLoginPassword ? faEyeSlash : faEye} />
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "2px 0 4px",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <input type="checkbox" style={{ accentColor: "var(--primary)" }} />
                <Text size="px14" weight="w400" color="gray6">
                  Remember me
                </Text>
              </label>
              <Text
                size="px14"
                weight="w400"
                color="gray6"
                extraStyles={{ cursor: "pointer" }}
              >
                Forgot Password
              </Text>
            </div>

            <Button
              type="submit"
              size="large"
              variant="fill"
              style={{ width: "100%", borderRadius: "43px", padding: "14px 0" }}
            >
              Login
            </Button>

            <button
              type="button"
              onClick={handleGoogleAuth}
              style={{
                width: "100%",
                borderRadius: "43px",
                padding: "14px 0",
                border: "1px solid var(--gray05)",
                backgroundColor: "var(--white)",
                color: "var(--gray9)",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Continue with Google
            </button>

            <Text
              size="px14"
              weight="w400"
              color="gray6"
              extraStyles={{ textAlign: "center", marginTop: "8px" }}
            >
              Don&apos;t have account?
              <button
                type="button"
                onClick={() => setMode("register")}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "var(--gray9)",
                  fontSize: "14px",
                  fontWeight: 500,
                  cursor: "pointer",
                  padding: 0,
                  marginLeft: "4px",
                  fontFamily: "inherit",
                }}
              >
                Register
              </button>
            </Text>
          </form>
        ) : (
          <form
            onSubmit={handleSignUp}
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <Input
              type="email"
              placeholder="Email"
              value={registerEmail}
              onChange={(event) => setRegisterEmail(event.target.value)}
              width="100%"
              containerStyle={{ maxWidth: "100%" }}
              inputStyle={{ fontSize: "14px", padding: "14px 16px" }}
            />

            <Input
              type="text"
              placeholder="Name"
              value={registerName}
              onChange={(event) => setRegisterName(event.target.value)}
              width="100%"
              containerStyle={{ maxWidth: "100%" }}
              inputStyle={{ fontSize: "14px", padding: "14px 16px" }}
            />

            <div style={inputShellStyle}>
              <Input
                type={showRegisterPassword ? "text" : "password"}
                placeholder="Password"
                value={registerPassword}
                onChange={(event) => setRegisterPassword(event.target.value)}
                width="100%"
                containerStyle={{ maxWidth: "100%" }}
                inputStyle={{ fontSize: "14px", padding: "14px 42px 14px 16px" }}
              />
              <button
                type="button"
                onClick={() => setShowRegisterPassword((current) => !current)}
                style={passwordToggleStyle}
              >
                <FontAwesomeIcon icon={showRegisterPassword ? faEyeSlash : faEye} />
              </button>
            </div>

            <div style={inputShellStyle}>
              <Input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                width="100%"
                containerStyle={{ maxWidth: "100%" }}
                inputStyle={{ fontSize: "14px", padding: "14px 42px 14px 16px" }}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword((current) => !current)}
                style={passwordToggleStyle}
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
              </button>
            </div>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                margin: "2px 0 4px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={acceptTerms}
                onChange={(event) => setAcceptTerms(event.target.checked)}
                style={{ accentColor: "var(--primary)" }}
              />
              <Text size="px14" weight="w400" color="gray6">
                Accept all Terms & Conditions
              </Text>
            </label>

            <Button
              type="submit"
              size="large"
              variant="fill"
              style={{ width: "100%", borderRadius: "43px", padding: "14px 0" }}
            >
              Create Account
            </Button>

            <button
              type="button"
              onClick={handleGoogleAuth}
              style={{
                width: "100%",
                borderRadius: "43px",
                padding: "14px 0",
                border: "1px solid var(--gray05)",
                backgroundColor: "var(--white)",
                color: "var(--gray9)",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Sign up with Google
            </button>

            <Text
              size="px14"
              weight="w400"
              color="gray6"
              extraStyles={{ textAlign: "center", marginTop: "8px" }}
            >
              Already have account?
              <button
                type="button"
                onClick={() => setMode("login")}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "var(--gray9)",
                  fontSize: "14px",
                  fontWeight: 500,
                  cursor: "pointer",
                  padding: 0,
                  marginLeft: "4px",
                  fontFamily: "inherit",
                }}
              >
                Login
              </button>
            </Text>
          </form>
        )}
      </div>
    </div>
  );
}
